import { useAtom } from "jotai";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { phoneNumberAtom } from "@/utils/atoms";

import { TwoFactorConfirmationInput } from "./TwoFactorConfirmationInput";

export const AuthenticatorSmsConfirmForm = ({
  resendAction,
}: {
  resendAction: () => void;
}) => {
  const { t } = useTranslation();
  const [phoneNumber] = useAtom(phoneNumberAtom);

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-secondary-100">
        {t("portal:authenticator.sms.verification.title")}
      </h1>
      <p>
        {t("portal:authenticator.sms.verification.description", {
          number: phoneNumber,
        })}
      </p>
      <TwoFactorSMSValidation resendAction={resendAction} />
    </div>
  );
};

export const TwoFactorSMSValidation = ({
  resendAction,
}: {
  resendAction: () => void;
}) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = debounce(() => resendAction(), 1000, {
    leading: true,
    trailing: false,
  });

  return (
    <div className="flex w-fit flex-col gap-2">
      <TwoFactorConfirmationInput />
      <button
        type="button"
        onClick={handleClick}
        disabled={countdown > 0}
        className="w-fit font-semibold text-highlight-100 underline disabled:opacity-50"
      >
        {t("portal:authenticator.sms.verification.resend")}
        {countdown > 0 &&
          ` ${t("portal:authenticator.sms.verification.secondsLeft", { count: countdown })}`}
      </button>
    </div>
  );
};
